import { NotFoundPage } from 'app/components/NotFoundPage';
import useAxios from 'axios-hooks';
import LoadPanel from 'app/components/LoadPanel';
import React, { createContext, useContext, useState } from 'react';

const List = React.lazy(() => import('./List'));
const View = React.lazy(() => import('./View'));

const TrackingInquiryContext = createContext({});
TrackingInquiryContext.displayName = 'TrackingInquiryContext';

export const useTrackingInquiry = () => {
  return useContext(TrackingInquiryContext);
};

/**
 * Tracking Inquiry
 *
 * @return {*}
 */
const TrackingInquiry = () => {
  // create state
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'list',
    data: null,
  });
  const [formSearchData, setFormSearchData] = useState<any>({
    fromDate: new Date(),
    endDate: new Date(),
    waybill: '',
    invoice: '',
    type: '',
    dataList: {
      store: [],
    },
    store: '',
  });
  // call api
  const [{ loading: loadingfetchData }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  // Values share with child component
  const value: any = {
    data,
    setData,
    modeView,
    setModeView,
    refetchData,
    formSearchData,
    setFormSearchData,
  };

  /**
   *Render Content component
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'view':
        return <View />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <TrackingInquiryContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loadingfetchData} />
        {renderContent()}
      </React.Suspense>
    </TrackingInquiryContext.Provider>
  );
};

export default TrackingInquiry;
